import { render, staticRenderFns } from "./duties.vue?vue&type=template&id=22ba0c7c"
import script from "./duties.vue?vue&type=script&lang=js"
export * from "./duties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports